/* eslint-disable no-unused-vars */
import React from 'react';
import { ErrorBoundary as ErrorBoundaryComponent } from 'react-error-boundary';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { PublicLayout } from './PublicLayout';
import RefreshTokenError from '../Errors/RefreshTokenError';
import { StyledFlex, StyledSubTitle, StyledTitle } from './ErrorBoundary.styles';
import UserConfigError from '../Errors/GetUserInfoError';

const Components = {
  GET_USER_INFO_ERROR: UserConfigError,
  REFRESH_TOKEN_ERROR: RefreshTokenError,
};
function DefaultFallbackComponent() {
  const intl = useIntl();

  return (
    <StyledFlex>
      <StyledTitle>{intl.formatMessage({ id: 'app.errorBoundary.title' })}</StyledTitle>
      <StyledSubTitle>{intl.formatMessage({ id: 'app.errorBoundary.subTitle' })}</StyledSubTitle>
      <div>
        {intl.formatMessage({ id: 'app.errorBoundary.backLink' })}
        &nbsp;
        <Link to="home">HomePage</Link>
      </div>
    </StyledFlex>
  );
}
function FallbackComponent({ error }) {
  const ErrorComponent = Components[error.message] || DefaultFallbackComponent;
  return (
    <PublicLayout>
      <ErrorComponent />
    </PublicLayout>
  );
}

FallbackComponent.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
};

export default function ErrorBoundary({ children }) {
  return (
    <ErrorBoundaryComponent FallbackComponent={FallbackComponent}>
      { children }
    </ErrorBoundaryComponent>
  );
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};
